<template>
  <custom-modal v-if="showDialog" modal-width="25rem" body-padding="0 24px 0px" @close="closeModal">
    <template #header>
      {{ editViewID ? $t("views.editView") : $t("views.addNewView") }}
    </template>

    <template #body>
      <form @submit.prevent="submit">
        <custom-input :value="title" type="text" :label="$t('views.title')" @input="title = $event" @close="closeModal">
        </custom-input>
        <div>
          <icon-select :icon="icon" @icon-selected="iconSelected" />
        </div>
        <div class="kk-viewdialog__btns">
          <custom-button button-class="btn btn-default btn-primary" button-type="submit" :mode="!isTitleValid">
            {{ editViewID ? $t("actions.update") : $t("actions.add") }}
          </custom-button>
          <custom-button button-class="btn btn-default" button-type="button" @click="closeModal">
            {{ $t("actions.cancel") }}</custom-button
          >
        </div>
      </form>
    </template>
    <template #footer>
      <span></span>
    </template>
  </custom-modal>
</template>

<script>
import DesignerMixin from "../DesignerMixin";
import IconSelect from "./IconSelect.vue";
import CustomButton from "../../commons/CustomButton.vue";
import CustomModal from "../../commons/CustomModal.vue";
import CustomInput from "../../commons/CustomInput.vue";

export default {
  components: { IconSelect, CustomButton, CustomModal, CustomInput },
  mixins: [DesignerMixin],
  data() {
    return {
      title: "",
      icon: "icon-bag-suitcase",
    };
  },
  computed: {
    isTitleValid() {
      return this.title && this.title.trim() !== "";
    },
    editViewID() {
      return this.$store.state.views.editingViewId;
    },
    showDialog: {
      get() {
        return this.$store.state.views.showAddViewDialog;
      },
      set(newValue) {
        return this.$store.dispatch("views/setShowAddViewDialog", newValue);
      },
    },
  },
  watch: {
    editViewID(newValue, oldValue) {
      if (newValue) {
        // Trigger action when isEditMode becomes true
        this.handleEditModeChange();
      }
    },
  },
  methods: {
    handleEditModeChange() {
      // Add your logic here to handle changes in isEditMode
      const editedView = this.$store.state.views.allViews.find((view) => view._id === this.editViewID);
      if (editedView) {
        this.title = editedView.title;
        this.icon = editedView.icon;
      }
    },
    closeModal() {
      this.showDialog = !this.showDialog;
      this.title = "";
      this.icon = "icon-bag-suitcase";
      this.$store.dispatch("views/setEditingViewID", null);
    },
    iconSelected(icon) {
      this.icon = icon;
    },
    sanitizeTitle() {
      this.title = this.title.replace(/\s+/g, " ").trim();
    },
    async submit() {
      this.sanitizeTitle();
      if (this.editViewID) {
        await this.$store.dispatch("views/updateView", {
          id: this.editViewID,
          title: this.title,
          icon: this.icon,
        });
      } else {
        await this.$store.dispatch("views/addView", {
          title: this.title,
          icon: this.icon,
          designId: this.current.id,
        });
      }
      this.closeModal();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";

.kk-viewdialog {
  &__btns {
    display: flex;
    gap: 10px;
    padding-top: 1rem;
    justify-content: right;
  }
}
</style>
